import { Skeleton } from '@bp/ui-components';
import { BpPage } from 'components/BpPage/BpPage';
import { useAuthClaims } from 'hooks/useAuthClaims';
import { useTranslation } from 'react-i18next';

export function MaterialArchivePage() {
  const { t } = useTranslation();
  const { pimAuthClaims } = useAuthClaims();

  return (
    <BpPage title={t('materialArchive.title')} isForbidden={false} organization={pimAuthClaims.getOrganization()}>
      <Skeleton />
    </BpPage>
  );
}
